// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"link-list_sectionTitle__vljlF","list":"link-list_list__VPCAb","listItem":"link-list_listItem__0VwA5"};